<template>
    <div>
        <rkm-table
            :fields="fields"
            :filter="model.filter"
            :items="items"
            ref="RkmTable"
        >
            <template v-slot:filters>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidade"
                            disabled
                            label="Unidade"
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestrutura"
                            disabled
                            label="Local de atendimento"
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            label="Buscar"
                            placeholder="Digite para buscar"
                            v-model="model.filter"
                        />
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    v-if="item.modulos.length > 1"
                    @click="$refs.ModalModulo.open(item)"
                    color="primary"
                    small
                    title="Selecionar módulo"
                >
                    <rkm-icon icon="th" />
                </rkm-button>

                <rkm-button
                    v-else
                    @click="openScreen(item)"
                    color="primary"
                    small
                    target="_blank"
                    title="Ver tela"
                >
                    <rkm-icon icon="tv" />
                </rkm-button>

                <rkm-button
                    @click="edit(item)"
                    authorize="update-painel-senha-tela"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(item)"
                    authorize="destroy-painel-senha-tela"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalModulo ref="ModalModulo" />
    </div>
</template>

<script>
// Components.
import ModalModulo from './components/modulo/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {ModalModulo},
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return [
                { key: 'nome', label: 'Tela', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    created() {
        this.repositories = {
            tela: this.getConectaSusRepository('painelSenha.tela')
        }
    },
    data: () => ({
        form: {
            unidade: [],
            infraestrutura: [],
        },
        items: [],
        model: {
            filter: null,
            unidadeId: null,
            infraestruturaId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.tela.index()
                .then(response => {
                    this.form.unidade =  [{
                        id: this.lotacao.infraestrutura.unidade.id,
                        nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                    }]

                    this.form.infraestrutura = [{
                        id: this.lotacao.infraestrutura.id,
                        nome: this.lotacao.infraestrutura.nome,
                    }]

                    this.items = response.data

                    this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
                    this.model.infraestruturaId = this.lotacao.infraestrutura.id
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(item) {
            this.$router.push({ name: 'painel-senha-tela-edit', params: { id: item.id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.tela.destroy(item.id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === item.id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir a tela?', destroy, this.handleError)
        },
        openScreen(item) {
            if (item.modulos && item.modulos.length === 0) {
                this.showWarningNotification('É necessário parametrizar ao menos um módulo para utilizar a tela.')
            } else {
                let params = {
                    name: 'painel-senha-tela-show',
                    params: {id: item.id},
                    query: {modulos: item.modulos[0].id}
                }

                const route = this.$router.resolve(params)

                window.open(route.href, '_blank')
            }
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>